const AccessGroupStrategies = {
  /**
   * Everyone in the company
   */
  everyone: 'everyone',
  /**
   * A specific list of users.
   */
  members: 'members',
  /**
   * A customizable query to fetch accesses
   */
  fqlMultiselect: 'fqlmultiselect',
} as const

export default AccessGroupStrategies
